import { useStorage } from '@/js/libs/hooks/useStorage';

export enum StorageScope {
  GENERAL = 'adnz',
  NOTIFICATIONS = `${StorageScope.GENERAL}_notifications`,
  NOTIFICATIONS_CRITICAL_BANNER = `${StorageScope.NOTIFICATIONS}_critical_banner`,
  NOTIFICATIONS_SYSTEM = `${StorageScope.NOTIFICATIONS}_system`,
  NOTIFICATIONS_COMMENTS = `${StorageScope.NOTIFICATIONS}_comments`,
  ACCOUNTS_LIST = `${StorageScope.GENERAL}_accounts_list`,
  ADMIN_USERS = `${StorageScope.GENERAL}_admin_users`,
  ADMIN_COMPANIES = `${StorageScope.GENERAL}_admin_companies`,
  ADMIN_MAIL = `${StorageScope.GENERAL}_admin_mail`,
  ADMIN_MAIL_CONSOLE = `${StorageScope.ADMIN_MAIL}_console`,
  ADMIN_MAIL_SALES_PROMOTIONS = `${StorageScope.ADMIN_MAIL}_sales_promotions`,
  ADMIN_LOCALIZATION = `${StorageScope.GENERAL}_admin_localization`,
  ADMIN_BATCH_K8S = `${StorageScope.GENERAL}_admin_batch_k8s`,
  ADMIN_XANDR_SEGMENTS = `${StorageScope.GENERAL}_admin_xandr_segments`,
  ADMIN_WEBSITE_MAPPING = `${StorageScope.GENERAL}_admin_website_mapping`,
  ADMIN_WEBSITE_GROUPS = `${StorageScope.GENERAL}_admin_website_groups`,
  ADMIN_SUPPORT_CHAT = `${StorageScope.GENERAL}_admin_support_chat`,
  CONTACTS_LIST = `${StorageScope.GENERAL}_contacts_list`,
  POST_CONTACTS_LIST = `${StorageScope.GENERAL}_post_contacts_list`,
  COMPLIANCE = `${StorageScope.GENERAL}_compliance`,
  COMPLIANCE_PRICE_LIST_CHANGES = `${StorageScope.COMPLIANCE}_list_price_changes`,
  COMPLIANCE_ACCOUNT_FINANCIALS = `${StorageScope.COMPLIANCE}_account_financials`,
  COMPLIANCE_POSITION_FINANCIALS = `${StorageScope.COMPLIANCE}_position_financials`,
  COMPLIANCE_CREDIT_NOTES = `${StorageScope.COMPLIANCE}_credit_notes`,
  CREATIVES_PRINT = `${StorageScope.GENERAL}_creatives_print`,
  CREDIT_CARD_RECEIPTS = `${StorageScope.GENERAL}_credit_card_receipts`,
  CREDIT_CARD_RECEIPTS_PAYMENTS = `${StorageScope.CREDIT_CARD_RECEIPTS}_payments`,
  CREDIT_CARD_RECEIPTS_PAYOUTS = `${StorageScope.CREDIT_CARD_RECEIPTS}_payouts`,
  DIGITAL_CREATIVES = `${StorageScope.GENERAL}_digital_creatives`,
  ADSERVER_CREATIVES = `${StorageScope.GENERAL}_adserver_creatives`,
  CREATIVE_TEMPLATES = `${StorageScope.GENERAL}_creative_templates`,
  FINANCES_PAYMENTS = `${StorageScope.GENERAL}_finances_payments`,
  FINANCES_COMPANY_CONFIGS = `${StorageScope.GENERAL}_finances_company_configs`,
  GEN_AI_SETTINGS = `${StorageScope.GENERAL}_gen_ai_settings`,
  GEN_AI_SETTINGS_AGENTS = `${StorageScope.GEN_AI_SETTINGS}_agents`,
  GEN_AI_SETTINGS_BRAND_KITS = `${StorageScope.GEN_AI_SETTINGS}_brand_kits`,
  GEN_AI_SETTINGS_MCP_SERVERS = `${StorageScope.GEN_AI_SETTINGS}_mcp_servers`,
  TAGS_LIST_SERVER = `${StorageScope.GENERAL}_tags_list_server`,
  TAGS_LIST_CLIENT = `${StorageScope.GENERAL}_tags_list_client`,
  ORDERS = `${StorageScope.GENERAL}_orders`,
  POINT_OF_SALE_SETTINGS = `${StorageScope.GENERAL}_point_of_sale_settings`,
  PUBLISHERS_EXCLUSIONS = `${StorageScope.GENERAL}_publishers_exclusions`,
  PUBLISHERS_PAYOUTS = `${StorageScope.GENERAL}_publishers_payouts`,
  PUBLISHERS_PAYOUTS_DATE = `${StorageScope.GENERAL}_publishers_payouts_date`,

  PUBLISHERS_CAMPAIGNS = `${StorageScope.GENERAL}_publishers_campaigns`,
  PUBLISHERS_OVERVIEW = `${StorageScope.GENERAL}_publishers_overview`,
  PUBLISHERS_WEBSITE = `${StorageScope.GENERAL}_publishers_website`,
  POSITION_GROUPS_SETTINGS = `${StorageScope.GENERAL}_position_groups_settings`,
  POINT_OF_SALE_SETTINGS_AD_MEDIA = `${StorageScope.POINT_OF_SALE_SETTINGS}_ad_media`,
  POINT_OF_SALE_SETTINGS_PLACEMENTS = `${StorageScope.POINT_OF_SALE_SETTINGS}_placements`,
  POINT_OF_SALE_SETTINGS_AD_TYPES = `${StorageScope.POINT_OF_SALE_SETTINGS}_ad_types`,
  POINT_OF_SALE_SETTINGS_PRODUCTS = `${StorageScope.POINT_OF_SALE_SETTINGS}_products`,
  POINT_OF_SALE_SETTINGS_AD_PRICES = `${StorageScope.POINT_OF_SALE_SETTINGS}_ad_prices`,
  CONSULTING_SETTINGS = `${StorageScope.GENERAL}_consulting_settings`,
  CONSULTING_SETTINGS_AD_MEDIA = `${StorageScope.CONSULTING_SETTINGS}_ad_media`,
  CONSULTING_SETTINGS_PLACEMENTS = `${StorageScope.CONSULTING_SETTINGS}_placements`,
  CONSULTING_SETTINGS_AD_TYPES = `${StorageScope.CONSULTING_SETTINGS}_ad_types`,
  CONSULTING_SETTINGS_PRODUCTS = `${StorageScope.CONSULTING_SETTINGS}_products`,
  CONSULTING_SETTINGS_AD_PRICES = `${StorageScope.CONSULTING_SETTINGS}_ad_prices`,
  PRINT_OPERATIONS_PUBLICATION = `${StorageScope.GENERAL}_print_operations_publication`,
  PRINT_OPERATIONS_PRINT = `${StorageScope.GENERAL}_print_operations_print`,
  DIGITAL_OPERATIONS_QUALITY_ASSURANCE = `${StorageScope.GENERAL}_digital_operations_quality_assurance`,
  ANALOG_OPERATIONS_CAMPAIGN_MANAGEMENT = `${StorageScope.GENERAL}_analog_operations_campaign_management`,
  RAW_SCRIPTS_LIST = `${StorageScope.GENERAL}_raw_scripts_list`,
  RADIO_PRODUCTS = `${StorageScope.GENERAL}_radio_products`,
  RADIO_PRODUCTS_PLACEMENTS = `${StorageScope.GENERAL}_radio_products_placements`,
  RADIO_PRODUCTS_PRICES = `${StorageScope.GENERAL}_radio_products_prices`,
  RADIO_PRODUCTS_AD_MEDIA = `${StorageScope.GENERAL}_radio_products_ad_media`,
  RADIO_PRODUCTS_AD_TYPES = `${StorageScope.GENERAL}_radio_products_ad_types`,
  SALES_SOURCES = `${StorageScope.GENERAL}_sales_sources`,
  SALES_TAGS = `${StorageScope.GENERAL}_sales_tags`,
  SALES_ACTIVITIES = `${StorageScope.GENERAL}_sales_activities`,
  SALES_COMMENTS = `${StorageScope.GENERAL}_sales_comments`,
  SALES_TASK_TABLE = `${StorageScope.GENERAL}_sales_task_table`,
  SALES_TASK_TOPICS = `${StorageScope.GENERAL}_sales_task_topics`,
  SALES_UNITS_SETTINGS = `${StorageScope.GENERAL}_sales_units_settings`,
  SALES_PROMOTIONS = `${StorageScope.GENERAL}_sales_promotions`,
  SALES_PROMOTIONS_TYPE_CONFIGS = `${StorageScope.SALES_PROMOTIONS}_type_configs`,
  SALES_PROMOTIONS_PROMOTION_DETAILS = `${StorageScope.SALES_PROMOTIONS}_promotion_details`,
  SETTINGS = `${StorageScope.GENERAL}_settings`,
  SETTINGS_LABELS = `${StorageScope.SETTINGS}_labels`,
  SETTINGS_WEBSITES = `${StorageScope.SETTINGS}_websites`,
  SETTINGS_PASSENDO_WEBSITES_MAPPING = `${StorageScope.SETTINGS}_passendo_websites_mapping`,
  SETTINGS_ADMANAGER_MAPPINGS_WEBSITES = `${StorageScope.SETTINGS}_admanager_mappings_websites`,
  SETTINGS_ADOMIK_MAPPINGS_WEBSITES = `${StorageScope.SETTINGS}_adomik_mappings_websites`,
  SETTINGS_ADOMIK_BRANDS_MAPPING = `${StorageScope.SETTINGS}_adomik_brands_mapping`,
  SETTINGS_ADOMIK_DEALS_BUYER_MAPPINGS = `${StorageScope.SETTINGS}_adomik_deals_buyer_mappings`,
  SETTINGS_ADOMIK_MAPPINGS_DEALS = `${StorageScope.SETTINGS}_adomik_mappings_deals`,
  SETTINGS_ADOMIK_SSP_MAPPINGS = `${StorageScope.SETTINGS}_adomik_ssp_mappings`,
  SETTINGS_ADOMIK_SEATS = `${StorageScope.SETTINGS}_adomik_seats`,
  SETTINGS_ADMANAGER_MAPPINGS_DEALS_DBE = `${StorageScope.SETTINGS}_admanager_mappings_deals_dbe`,
  SETTINGS_ADMANAGER_MAPPINGS_BUYER_MAPPINGS = `${StorageScope.SETTINGS}_admanager_mappings_buyer_mappings`,
  SETTINGS_ADMANAGER_MAPPINGS_BRANDS_MAPPING = `${StorageScope.SETTINGS}_admanager_mappings_brands_mapping`,
  SETTINGS_ACCOUNT_TYPES = `${StorageScope.SETTINGS}_account_types`,
  SETTINGS_INDUSTRIES = `${StorageScope.SETTINGS}_industries`,
  SETTINGS_POSITION_GROUPS = `${StorageScope.SETTINGS}_position_groups`,
  SETTINGS_PRICE_LISTS = `${StorageScope.SETTINGS}_price_lists`,
  SETTINGS_XANDR_PROGRAMMATIC = `${StorageScope.SETTINGS}_xandr_programmatic`,
  SETTINGS_XANDR_PROGRAMMATIC_BUYER_MAPPINGS = `${StorageScope.SETTINGS_XANDR_PROGRAMMATIC}_buyer_mappings`,
  SETTINGS_XANDR_PROGRAMMATIC_BRANDS_MAPPING = `${StorageScope.SETTINGS_XANDR_PROGRAMMATIC}_brands_mapping`,
  SETTINGS_XANDR_PROGRAMMATIC_WEBSITES_MAPPING = `${StorageScope.SETTINGS_XANDR_PROGRAMMATIC}_websites_mapping`,
  SETTINGS_XANDR_PROGRAMMATIC_DEALS_DBE = `${StorageScope.SETTINGS_XANDR_PROGRAMMATIC}_deals_dbe`,
  SETTINGS_XANDR_PROGRAMMATIC_DEALS = `${StorageScope.SETTINGS_XANDR_PROGRAMMATIC}_deals`,
  TV_PRODUCTS = `${StorageScope.GENERAL}_tv_products`,
  TV_PRODUCTS_PRICES = `${StorageScope.GENERAL}_tv_products_prices`,
  TV_PRODUCTS_PLACEMENTS = `${StorageScope.GENERAL}_tv_products_placements`,
  TV_PRODUCTS_AD_MEDIA = `${StorageScope.GENERAL}_tv_products_ad_media`,
  TV_PRODUCTS_AD_TYPES = `${StorageScope.GENERAL}_tv_products_ad_types`,
  CAMPAIGN_TYPES = `${StorageScope.SETTINGS}_campaign_types`,
  SEMANTIQ_CUSTOM_AUDIENCES = `${StorageScope.GENERAL}_semantiq_custom_audiences`,
  SEMANTIQ_CUSTOM_AUDIENCES_HISTORY = `${StorageScope.GENERAL}_semantiq_custom_audiences_history`,
  SEMANTIQ_IAB_AUDIENCES = `${StorageScope.GENERAL}_semantiq_iab_audiences`,
  SETTINGS_DIGITAL_PRODUCTS = `${StorageScope.GENERAL}_settings_digital_products`,
  SETTINGS_DIGITAL_PRICES = `${StorageScope.GENERAL}_settings_digital_products_prices`,
  SETTINGS_DIGITAL_AD_MEDIA = `${StorageScope.GENERAL}_settings_digital_products_ad_media`,
  SETTINGS_DIGITAL_AD_TYPES = `${StorageScope.GENERAL}_settings_digital_products_ad_types`,
  SETTINGS_DIGITAL_PLACEMENTS = `${StorageScope.GENERAL}_settings_digital_products_placements`,
  TARGETING_VISITOR_SEGMENTS = `${StorageScope.GENERAL}_targeting_visitor_segments`,
  POINT_OF_SALE_POSITIONS_LIST = `${StorageScope.GENERAL}_point_of_sale_positions_list`,
  PROGRAMMATIC_DEALS = `${StorageScope.GENERAL}_programmatic_deals`,
  COMMENTS = `${StorageScope.ORDERS}_comments`,
  BOOKING = `${StorageScope.ORDERS}_booking`,
  BOOKING_TYPE_FILTER = `${StorageScope.ORDERS}_booking_type_filter`,
  CORRESPONDENCE_SETTINGS_ENTITY_LIST = `${StorageScope.GENERAL}_correspondence_settings_entity_list`,
  CAMPAIGNS_LIST = `${StorageScope.GENERAL}_campaign_list`,
  POST_CAMPAIGNS_LIST = `${StorageScope.GENERAL}_post_campaigns_list`,
  DIGITAL_POSITIONS = `${StorageScope.GENERAL}_digital_positions`,
  PRINT_POSITIONS = `${StorageScope.GENERAL}_print_positions`,
  BROADCAST_POSITIONS = `${StorageScope.GENERAL}_broadcast_positions`,
  BROADCAST_POSITIONS_RADIO = `${StorageScope.BROADCAST_POSITIONS}_radio`,
  BROADCAST_POSITIONS_TV = `${StorageScope.BROADCAST_POSITIONS}_tv`,
  CONSULTING_POSITIONS = `${StorageScope.GENERAL}_consulting_positions`,
  FLOOR_RULES_LIST = `${StorageScope.GENERAL}_floor_rules_list`,
  DEFAULT_CONFIGS_LIST = `${StorageScope.GENERAL}_default_configs_list`,
  YALEO_BTA_FEED_WEBSITES_LIST = `${StorageScope.GENERAL}_yaleo_bta_feed_websites_list`,
  YALEO_CRAWLER_CONFIGURATION = `${StorageScope.GENERAL}_yaleo_crawler_configuration`,
  YALEO_PLACEMENTS = `${StorageScope.GENERAL}_yaleo_placements`,
  YALEO_COLLECT = `${StorageScope.GENERAL}_yaleo_collect`,
  YALEO_SETTINGS_MAPPING = `${StorageScope.GENERAL}_yaleo_settings_account_mapping`,
  SELF_BOOKING = `${StorageScope.GENERAL}_self_booking`,
  SELF_BOOKING_RECEIPTS = `${StorageScope.SELF_BOOKING}_receipts`,
  SELF_BOOKING_RECEIPTS_PAYMENTS = `${StorageScope.SELF_BOOKING_RECEIPTS}_payments`,
  SELF_BOOKING_RECEIPTS_PAYOUTS = `${StorageScope.SELF_BOOKING_RECEIPTS}_payouts`,
  SELF_BOOKING_CAMPAIGNS_LIST = `${StorageScope.SELF_BOOKING}_campaigns_list`,
  SELF_BOOKING_CAMPAIGN_HISTORY = `${StorageScope.SELF_BOOKING}_campaign_history`,
  SELF_BOOKING_ADVERTISERS_LIST = `${StorageScope.SELF_BOOKING}_advertisers_list`,
  SELF_BOOKING_CREATIVES_LIST = `${StorageScope.SELF_BOOKING}_creatives_list`,
  SELF_BOOKING_CREATIVES_APPROVAL_LIST = `${StorageScope.SELF_BOOKING}_creatives_approval_list`,
  SELF_BOOKING_SCREENSHOT_MANAGEMENT_LIST = `${StorageScope.SELF_BOOKING}_screenshot_management_list`,
  SELF_BOOKING_INVOICING_LIST = `${StorageScope.SELF_BOOKING}_invoicing_list`,
  SELF_BOOKING_POSITIONS_LIST = `${StorageScope.SELF_BOOKING}_positions_list`,
  PAYOUTS_STATE_FILTER = `${StorageScope.GENERAL}_PAYOUTS_STATE_FILTER`,
  COMPANY_SETTINGS_COOP_WEEKS = `${StorageScope.GENERAL}_company_settings_coop_weeks_list`,
  SETTINGS_PRINT_PRODUCTS_AD_MEDIAS = `${StorageScope.SETTINGS}_print_products_ad_medias`,
  SETTINGS_PRINT_PRODUCTS_PLACEMENTS = `${StorageScope.SETTINGS}_print_products_placements`,
  SETTINGS_PRINT_PRODUCTS_AD_TYPES = `${StorageScope.SETTINGS}_print_products_ad_types`,
  SETTINGS_PRINT_PRODUCTS = `${StorageScope.SETTINGS}_print_products`,
  SETTINGS_PRINT_PRODUCTS_AD_PRICES = `${StorageScope.SETTINGS}_print_products_ad_prices`,
  SETTINGS_PRINT_PRODUCTS_CALENDARS = `${StorageScope.SETTINGS}_print_products_calendars`,
  SETTINGS_PRINT_PRODUCTS_SIZE_CONFIGS = `${StorageScope.SETTINGS}_print_products_size_configs`,
  SETTINGS_PRINT_PRODUCTS_AVAILABILITIES = `${StorageScope.SETTINGS}_print_products_availabilities`,
  SETTINGS_REFERENCE_PER_ADMEDIA = `${StorageScope.SETTINGS}_reference_per_admedia`,
  SETTINGS_SPECIAL_DISCOUNTS = `${StorageScope.SETTINGS}_special_discounts`,
  SETTINGS_CONTRACTS = `${StorageScope.SETTINGS}_contracts`,
  ANALYTICS_TOOL = `${StorageScope.GENERAL}_analytics_tool`,
  ANALYTICS_TOOL_PAGE_IMPRESSIONS = `${StorageScope.ANALYTICS_TOOL}_page_impressions`,
  ANALYTICS_TOOL_AD_IMPRESSIONS = `${StorageScope.ANALYTICS_TOOL}_ad_impressions`,
  SUPPORT_CENTER = `${StorageScope.GENERAL}_support_center`,
  SUPPORT_CENTER_TICKETS = `${StorageScope.SUPPORT_CENTER}_tickets`,
  BI_DASHBOARDS = `${StorageScope.GENERAL}_bi_dashboards`,
  BI_WIDGETS = `${StorageScope.GENERAL}_bi_widgets`,
  BI_REPORTING = `${StorageScope.GENERAL}_bi_reporting`,
  BID_REDUCTION_CONFIGS = `${StorageScope.GENERAL}_bid_reduction_configs`,
  USER_GROUPS = `${StorageScope.GENERAL}_user_groups`,
}

export enum StorageKey {
  SAVED_SEARCH = 'saved_search',
  FILTERS = 'filters',
  DISMISSED_NOTIFICATION_ID = 'dismissed_notification_id',
}

const useSessionStorage = (scope = StorageScope.GENERAL) => useStorage<StorageKey, StorageScope>({ scope, storage: window.sessionStorage });

export default useSessionStorage;
